/**
 * /frontend/src/features/analytics/components/offers/AudienceComparisonChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import GroupedBarChart from '../charts/GroupedBarChart';
import { CHART_COLORS } from '../../constants/chartColors';
import { formatPercent } from '../../utils/formatters';

/**
 * Engagement and redemption rates across target audiences.
 * @param {{data:Array<{audience:string,engagementRate:number,redemptionRate:number}>}} props
 * @returns {JSX.Element}
 */
const AudienceComparisonChart = ({ data }) => {
  const bars = useMemo(() => ([
    { key: 'engagementRate', label: 'Engagement %', color: CHART_COLORS.accent },
    { key: 'redemptionRate', label: 'Redemption %', color: CHART_COLORS.warning }
  ]), []);

  return (
    <ChartContainer title="Audience Comparison" subtitle="Engagement and redemption by audience">
      <GroupedBarChart data={data} xKey="audience" bars={bars} yFormatter={(v) => formatPercent(v)} />
    </ChartContainer>
  );
};

export default AudienceComparisonChart;

